// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__BAtq4","addWidgetButton":"Header_addWidgetButton__D_g9l","dashboardTabs":"Header_dashboardTabs__1UM__","active":"Header_active__1Bcnz"};